import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
import { DEFAULT_DRIVER_GROUP, getDrivers } from '../../utils';

/**
 * Export all the keys of overridable driverGroups
 */
export var DRIVER_GROUPS_INVESTING = {};
/**
 * @param {Object} args -
 * @param {Object} args.marketplaceEntity -
 * @returns {Object[]} - list of quick-fact objects.
 */

var getDefaultDrivers = function getDefaultDrivers(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  return [quickFactMappings.investing.getQuickFactFees(marketplaceEntity), quickFactMappings.investing.getQuickFactAccountMinimum(marketplaceEntity), quickFactMappings.investing.getQuickFactPromotion(marketplaceEntity)];
};
/**
 * Define config of how to create drivers based off a driverGroup and other props
 */


var DRIVER_GROUP_CONFIG = _defineProperty({}, DEFAULT_DRIVER_GROUP, getDefaultDrivers);

export default (function (_ref2) {
  var driverGroup = _ref2.driverGroup,
      marketplaceEntity = _ref2.marketplaceEntity;
  return {
    drivers: getDrivers({
      driverGroupConfig: DRIVER_GROUP_CONFIG,
      driverGroup: driverGroup,
      marketplaceEntity: marketplaceEntity
    })
  };
});